import { render, staticRenderFns } from "./EditTagKeyValueSpendLimitDialog.vue?vue&type=template&id=1379ba5e&"
import script from "./EditTagKeyValueSpendLimitDialog.vue?vue&type=script&lang=js&"
export * from "./EditTagKeyValueSpendLimitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports